import React, { memo } from 'react'

import { string } from 'prop-types'

import LogoMark from 'images/cg_icon_rgb_small.svg'
import LogoWordmark from 'images/cgtrader_RGB.svg'

function Logo({ url }) {
  return (
    <a
      className="unified-nav__logo"
      data-track-text=""
      data-track-label="Homepage"
      href={url}
    >
      <picture>
        <source media="(min-width: 390px)" srcSet={LogoWordmark} />
        <img
          className="unified-nav__logo-img"
          src={LogoMark}
          alt="CGTrader - 3D Models / 3D Designers"
          width="106"
          height="24"
        />
      </picture>
    </a>
  )
}

Logo.propTypes = {
  url: string.isRequired,
}

export default memo(Logo)
